<template>
	<span class="loading-spinner-wrapper" title="Loading...">
		<span class="loading-spinner">
			<span class="spinner-circle" />
			<span class="spinner-circle" />
			<span class="spinner-circle" />
			<span class="spinner-circle" />
		</span>
	</span>
</template>

<script>
export default {
	name: "LoadingSpinner",
};
</script>

<style lang="scss" scoped>
.loading-spinner-wrapper {
	display: block;
	padding: 30px 10px;
}
.loading-spinner {
	align-items: center;
	animation: spin 1.1s linear infinite;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: repeat(2, 1fr);
	height: 65px;
	justify-items: center;
	margin: auto;
	transform: rotateZ(45deg);
	width: 65px;

	.spinner-circle {
		background-color: #000;
		border-radius: 100%;
		height: 20px;
		width: 20px;

		&:nth-child(1) {
			background-color: #d100e6;
		}
		&:nth-child(2) {
			background-color: #fc9f00;
		}
		&:nth-child(3) {
			background-color: #ec1460;
		}
		&:nth-child(4) {
			background-color: #2f90fd;
		}
	}
}

@keyframes spin {
	0% {
		transform: rotateZ(45deg);
	}

	100% {
		transform: rotateZ(395deg);
	}
}
</style>
